import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useUserAuth } from '@/state/cookieContext';

/**
 * 사용자 인증 가드 컴포넌트
 *
 * 특정 권한을 가진 사용자만 접근할 수 있도록 라우트를 보호합니다.
 * - 사용자 권한(roles) 체크
 * - 권한이 없으면 로그인 페이지로 리다이렉션
 * - 이전 접근 경로 정보 보존
 * - 향후 세분화된 권한(permissions) 체계 지원 예정
 *
 * @param roles 접근 허용할 사용자 권한 목록
 * @param children 보호할 컴포넌트
 */
export default function UserAuthGuard({ roles, children }: { roles: string[]; children: React.ReactNode }) {
  const userAuth = useUserAuth();
  const location = useLocation();

  const hasRole = roles.some(role => userAuth?.roles.includes(role));

  if (!hasRole) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 추후 롤보다 작은 단위의 권한을 부여할 때 사용
  // const hasPermission = permissions
  //   ? permissions.some((permission) => user.permissions.includes(permission))
  //   : true;
  //
  // if (!hasPermission) {
  //   return <Navigate to="/login" state={{ from: location }} replace />;
  // }

  // if (!hasRole || !hasPermission) {
  //   return <Navigate to={redirectPath} state={{ from: location }} replace />;
  // }

  return children;
}
